/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import _ from 'lodash';
import Materials from './Materials';
import { Icon } from 'edrolo-style-guide';
import s from './styles.scss';

class MaterialsPopover extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    placement: PropTypes.string,
    attachments: PropTypes.object,
  };

  static defaultProps = {
    disabled: false,
    placement: 'bottom',
  };

  render() {
    const { attachments, placement, disabled, label, iconName, children } =
      this.props;

    const popover = (
      <Popover id={_.uniqueId()} className="materials-popover">
        <Materials attachments={attachments} />
      </Popover>
    );

    return (
      <OverlayTrigger
        ref="overlay"
        trigger="click"
        placement={placement}
        overlay={popover}
        rootClose
      >
        <button className={s.button} disabled={disabled} type="button">
          <Icon name={iconName} />
          {children || label}
        </button>
      </OverlayTrigger>
    );
  }
}

export default MaterialsPopover;
